<template>
  <div class="d-flex justify-content-end align-items-baseline">
    <h6 class="pr-3">Show:</h6>
    <b-form-select
      ref="base__select-lu-status"
      v-model="$selected"
      :options="options"
      class="base__select-lu-status"
    >
    </b-form-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: {
      type: String,
      default: 'Submitted for publication'
    }
  },

  data() {
    return {
      options: ['Draft', 'Submitted for publication', 'Published'],
      sortDatas: {
        Draft: {
          is_published: false,
          required_review: false,
          _sort: 'created_at:desc'
        },
        'Submitted for publication': {
          required_review: true,
          is_published: false,
          _sort: 'submitted_review_at:asc'
        },
        Published: { is_published: true, _sort: 'published_at:desc' }
      }
    };
  },

  computed: {
    $selected: {
      get() {
        return this.selected;
      },

      set(v) {
        return this.$emit('change', v);
      }
    }
  },

  methods: {
    // onChangeParams(v) {
    //   this.$emit("sorting", this.getSorting(v));
    // },

    getSorting(v) {
      return this.sortDatas[v];
    }
  }
};
</script>

<style lang="scss" scoped>
.w-25 {
  width: 25%;
}
</style>
